import React from "react";

const CustomLoadingComponent = () => {
    return (
        <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.5)] flex flex-col gap-2 justify-center items-center z-[9999] pointer-events-auto">
            <div className="w-[40px] h-[40px] border-[2px] border-[#f3f3f3] border-t-[2px] border-t-[#3498db] rounded-[50%] animate-spin"></div>
            <div className="text-white text-xs">請稍後...</div>
        </div>
    )
}

export default CustomLoadingComponent;
